module.exports = __webpack_public_path__ + "static/media/study 210825.942054a4.png";